import { z } from 'zod';

import { textLengthLimit } from '../../NegotiationSupplierIntroductionWidget.util';

export const supplierIntroductionFormDataSchema = z.object({
  text: z.string().max(textLengthLimit),
  language: z.string().transform((value) => value.toLowerCase()),
});

export type IntakeRequestDescriptionStepFormData = z.infer<typeof supplierIntroductionFormDataSchema>;

export type SupplierIntroductionFormData = z.infer<typeof supplierIntroductionFormDataSchema>;
